import { render, staticRenderFns } from "./InvoicesSubVendors.vue?vue&type=template&id=74554a22&"
import script from "./InvoicesSubVendors.vue?vue&type=script&lang=js&"
export * from "./InvoicesSubVendors.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesSubVendors.vue?vue&type=style&index=0&id=74554a22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports